import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  description:
    "Let us see what will happen under certain events in VR. Now the source position changes, then the filter chain updates as fast as possible the related parts.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "video",
            options: {
              src: `${config.ASSETS_URL}/03/29/principle/principle-2.m4v`,
            },
          },
          styles: {
            padding: "2.5% 2%",
          },
        },
      },
    },
  },
};

export default principle;
